/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 13 2019 11:05:35 PM
 *
 *******************************************************/
//@flow
import _ from 'lodash';
import React, { Component } from 'react';
import { Layout, Card, Heading, Stack, Button } from '@shopify/polaris';
import { Carousel } from 'react-responsive-carousel';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import imageLoader from 'src/constants/migration-slider';

type State = {
  sliderImages: Object,
  currentSlide: number
};

class Slider extends Component<WithI18nProps, State> {
  state = {
    sliderImages: [],
    currentSlide: 0
  };

  componentDidMount() {
    const sliderImages = imageLoader();
    if (!_.isEmpty(sliderImages)) {
      this.setState({ sliderImages });
    }
  }

  next = () => {
    this.setState(state => ({
      currentSlide: state.currentSlide + 1
    }));
  };

  prev = () => {
    this.setState(state => ({
      currentSlide: state.currentSlide - 1
    }));
  };

  updateCurrentSlide = index => {
    const { currentSlide } = this.state;

    if (currentSlide !== index) {
      this.setState({
        currentSlide: index
      });
    }
  };

  render() {
    const { i18n } = this.props;
    const { sliderImages, currentSlide } = this.state;

    return (
      <Layout.Section>
        <Card sectioned>
          <div className="migration-slideshow">
            {!_.isEmpty(sliderImages) && (
              <Carousel
                selectedItem={currentSlide}
                onChange={this.updateCurrentSlide}
                showArrows={false}
                showThumbs={false}
                showStatus={false}
                showIndicators={true}>
                {sliderImages.map((image, index) => (
                  <div key={index}>
                    <div className="align-center card-title card-title-small">
                      <Heading>{i18n.translate(image.title)}</Heading>
                    </div>
                    <img src={image.src} alt="Setup guide" />
                    {image.content && (
                      <p className="slideshow-image-content">{image.content(i18n)}</p>
                    )}
                  </div>
                ))}
              </Carousel>
            )}
            <div className="slideshow-button">
              <Stack distribution="equalSpacing">
                <Button onClick={this.prev} disabled={currentSlide === 0}>
                  {i18n.translate('AdminHTML.Common.Action.previous')}
                </Button>
                <Button
                  primary
                  onClick={this.next}
                  disabled={currentSlide === sliderImages.length - 1}>
                  {i18n.translate('AdminHTML.Common.Action.next')}
                </Button>
              </Stack>
            </div>
          </div>
        </Card>
      </Layout.Section>
    );
  }
}

export default withI18n()(Slider);
